<template>
    <div>
        <!--设置语言-->
        <div class="set-body" v-show="flag||show">
            <div class="set-area">
                <div class="set-title">{{$t("langSetting")}}</div>
                <div class="set-select">
                    <div :class="{'lang-item':true,'lang-select':lang=='zh',}" @click="setLang('zh')">简体中文</div>
                    <div :class="{'lang-item':true,'lang-select':lang=='zh-tw',}" @click="setLang('zh-tw')">繁體中文</div>
                    <div :class="{'lang-item':true,'lang-select':lang=='en',}" @click="setLang('en')">English</div>
                    <div :class="{'lang-item':true,'lang-select':true}" style="width:1.5rem;margin:0.05rem auto;" @click="confirmLang()">{{$t("confirm")}}</div>
                </div>
                
            </div>
        </div>
        <div class="page-bottom">
            <div class="font-one">
                <div class="one-fonts">{{$t("fb")}}</div>
                <div class="atten-btn"><a href="https://www.facebook.com/mynovelapp" target="_blank">{{$t("focus")}}</a></div>
            </div>
            <div class="bottom-font">{{$t("kefu")}}miyuenovel@hotmail.com  LINE:mynovel123&nbsp;&nbsp;<a href="/policy.html" target="_blank">隐私协议</a></div>
            <div class="bottom-font">Copyright@2021 Miyue All rights reserved.</div>
        </div>
    </div>
</template>

<script>
export default {
  name: "pagebottom",
  props: ["flag", "setl"],
  data() {
    return {
      //  语言开关
      show: false,
      lang: ""
    };
  },
  mounted: function() {
    this.getUser();
  },
  methods: {
    getUser: function() {
      this.req.getUser().then(res => {
        console.info(res);
        if (res.data.id > 0) {
          this.lang =
            (res.data.lang == "zh-cn"||res.data.lang == "zh")
              ? "zh"
              : res.data.lang == "en"
                ? "en"
                : "zh-tw";
          this.$i18n.locale = this.lang;
        } else {
          if (localStorage.getItem("loginUserID") > 0) {
            let name = localStorage.getItem("myyueln");
            let password = localStorage.getItem("myyuelp");
            if (name != "" && password != "") {
              this.req.login(name, password).then(res => {
                if (res && res.status == 1) {
                  this.lang =
                    (res.data.lang == "zh-cn"||res.data.lang == "zh")
                      ? "zh"
                      : res.data.lang == "en"
                        ? "en"
                        : "zh-tw";
                  this.$i18n.locale = this.lang;
                }
                //如果有回跳，跳转至回跳
                var url = JSON.parse(localStorage.getItem("loginBack"));
                if (url) {
                  localStorage.removeItem("loginBack");
                  this.$router.push(url);
                } else {
                  this.go.backIndex();
                }
              });
            } else {
              //检查有没有设置过，没设置过的弹框
              let lang = localStorage.getItem("lang");
              if (lang) {
                this.lang = lang;
                this.$i18n.locale = this.lang;
              } else {
                this.show = true;
              }
            }
          } else {
            //检查有没有设置过，没设置过的弹框
            let lang = localStorage.getItem("lang");
            if (lang) {
              this.lang = lang;
              this.$i18n.locale = this.lang;
            } else {
              this.show = true;
            }
          }
        }
      });
    },
    confirmLang() {
      let lang = this.lang;
      if (this.setl) {
        this.setl(lang);
      }
      localStorage.setItem("lang", lang);
      this.$i18n.locale = lang;
      this.show = false;
      this.req.setLang(lang).then(()=>{
        document.location.reload();
      });
    },
    //设置语言
    setLang: function(lang) {
      this.lang = lang;
      localStorage.setItem("lang", lang);
      this.$i18n.locale = lang;
    }
  }
};
</script>

<style scoped>
.page-bottom {
  width: 100%;
  height: 2.13rem;
  background: #ff1f4f;
  box-sizing: border-box;
  padding: 0.33rem 0 0 0.4rem;
}
.bottom-font {
  font-size: 0.26rem;
  line-height: 0.26rem;
  color: #ffffff;
  margin-bottom: 0.2rem;
}
.font-one {
  display: flex;
  align-items: center;
  margin-bottom: 0.16rem;
  font-size: 0.26rem;
  line-height: 0.26rem;
  color: #ffffff;
}
.one-fonts {
  padding-right: 0.29rem;
}
.atten-btn {
  background: #ffffff;
  border-radius: 0.04rem;
  font-size: 0.22rem;
  line-height: 0.22rem;
  padding: 0.1rem 0.22rem;
  text-align: center;
}
.atten-btn a {
  color: #ff1f4f;
  text-decoration: none;
}
/*设置语言*/
.set-body {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  left: 0;
  top: 0;
}
.set-area {
  width: 4.74rem;
  height: 6.5rem;
  background: #ffffff;
  border-radius: 0.1rem;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  animation: scale 0.6s;
}
.set-title {
  width: 100%;
  height: 1.14rem;
  border-bottom: 0.02rem solid #e6e6e6;
  font-size: 0.34rem;
  color: #ff1f4f;
  text-align: center;
  line-height: 1.14rem;
  font-weight: 700;
}
.set-select {
  width: 100%;
  height: 4.5rem;
  box-sizing: border-box;
  padding: 1rem 0.86rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.lang-item {
  width: 100%;
  height: 0.76rem;
  background: #999999;
  color: #ffffff;
  font-size: 0.34rem;
  line-height: 0.76rem;
  font-weight: 700;
  border-radius: 0.08rem;
  text-align: center;
  margin: 0.1rem auto;
}
.lang-select {
  background: #ff1f4f;
}
</style>


// WEBPACK FOOTER //
// src/components/common/pagebottom.vue